import React from "react";
import "./xplLoader.component.scss"
import Modal from "../modal/modal.component"
import { Loader } from "@progress/kendo-react-indicators";

interface XplLoaderProps {
    progress?: number;
}

const XplLoader = ({ progress }: XplLoaderProps) => {
    return (
        <>
            <div className={"xpl-loader d-flex justify-content-center align-items-center"}>
                <Modal />
                <div className="loader-content">
                    <Loader type={"infinite-spinner"} size={"large"} />
                    {progress !== undefined && (
                        <div className="progress-text">
                            {progress}%
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default XplLoader;